import Reflux from 'reflux';

const AlarmCallbacksActions = Reflux.createActions({
  delete: { asyncResult: true },
  list: { asyncResult: true },
  save: { asyncResult: true },
  update: { asyncResult: true },
});

export default AlarmCallbacksActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/actions/alarmcallbacks/AlarmCallbacksActions.jsx